export default __webpack_public_path__ + "d46f99b09678b0bee688bbe646b00acc.webm";